const home = {
  "home.tagline": "La Télévision qui Vous Connecte",
  "home.intro":
    "L+TV TÉLÉVISION est un réseau de télévision et de médias numériques camerounais de premier plan basé à Edea, offrant des actualités, des diffusions en direct, des émissions, des sports, des divertissements et du contenu culturel aux téléspectateurs à travers le Cameroun et au-delà.",
  "home.watchLive": "REGARDER EN DIRECT",
  "home.watchVideos": "REGARDER LES VIDÉOS",
  "home.scroll": "Défiler",
  "home.latestNews": "Dernières Actualités",
  "home.viewAllNews": "Voir toutes les actualités",
  "home.featuredPrograms": "Émissions à la une",
  "home.viewAllPrograms": "Voir toutes les émissions",
  "home.latestVideos": "Dernières Vidéos",
  "home.viewAllVideos": "Voir toutes les vidéos",
  "home.openLive": "Ouvrir la TV en direct",
  "home.offline": "L+TV est actuellement hors ligne",
  "home.next": "Prochaine",
  "home.presenter": "Présentateur",
  "home.upNext": "À suivre",
  "home.connect": "Connectez-vous avec L+TV",
  "home.connectDesc":
    "Suivez L+TV sur les réseaux sociaux pour les dernières mises à jour, les sessions en direct et les coulisses.",
  "home.subscribeTitle": "Restez connecté avec L+TV",
  "home.subscribeDesc":
    "Abonnez-vous à notre newsletter pour recevoir les dernières actualités, les mises à jour des émissions et du contenu exclusif dans votre boîte mail.",
  "home.subscribeSuccess": "Merci de vous être abonné !",
  "home.subscribeSuccessDesc": "Vous recevrez désormais les mises à jour de L+TV TÉLÉVISION.",
  "home.yourName": "Votre nom",
  "home.yourEmail": "Votre adresse e-mail",
  "home.subscribe": "S'abonner",
  "home.bySubscribing":
    "En vous abonnant, vous acceptez de recevoir des e-mails de L+TV. Vous pouvez vous désabonner à tout moment.",
  "home.featuredAnnouncements": "Annonces à la une",
  "home.sponsoredCampaigns": "Campagnes sponsorisées et spéciales",
  "home.campaign": "Campagne",
  "home.learnMore": "En savoir plus",
  "home.breaking": "Urgent",
  "home.advertisement": "Publicité",
  "home.latestNewsLabel": "Dernières actualités",
  "home.welcome": "Bienvenue sur L+TV — la télévision qui vous connecte",
  "home.social.youtube": "YouTube",
  "home.social.youtubeDesc":
    "Abonnez-vous à L+TV pour les émissions complètes, les reportages et le contenu vidéo exclusif.",
  "home.social.youtubeCta": "S'abonner sur YouTube",
  "home.social.facebook": "Facebook",
  "home.social.facebookDesc":
    "Suivez notre page Facebook pour les mises à jour en direct, les discussions communautaires et la couverture des événements.",
  "home.social.facebookCta": "Suivre sur Facebook",
  "home.social.tiktok": "TikTok",
  "home.social.tiktokDesc":
    "Regardez de courtes vidéos, des coulisses et des moments viraux de L+TV.",
  "home.social.tiktokCta": "Suivre sur TikTok",
  "newsletter.required": "Veuillez saisir votre nom et votre e-mail.",
  "newsletter.invalidEmail": "Veuillez saisir une adresse e-mail valide.",
  "newsletter.error": "Une erreur est survenue. Veuillez réessayer.",
  "newsletter.welcomeSubject": "Bienvenue dans notre newsletter",
  "newsletter.welcomeBody": "Merci de vous être abonné à L+TV TÉLÉVISION. Vous recevrez désormais les dernières actualités, les mises à jour des émissions et du contenu exclusif.",
};

export default home;